export function About() {
  return (
    <section id="sobre" className="py-24 bg-[#F0F9F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ad285e504bd5e1b1aa9e69a5b758c47/2b7f050b78fa30fcf12049291b0db3ba.png"
                alt="Mayara Benetero - Psicóloga Clínica"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="text-[#6B6B6B] text-sm mb-4 block">
              (Sobre Mim)
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Mayara Benetero
            </h2>
            <p className="text-xl text-[#7DD3C0] font-semibold mb-8">
              Psicóloga Clínica CRP 06/157636
            </p>

            <div className="space-y-6 text-[#6B6B6B] leading-relaxed">
              <p>
                Olá! Sou psicóloga clínica com formação em Terapia Cognitivo-Comportamental e anos de experiência no atendimento de adolescentes, adultos e casais. Minha missão é criar um espaço onde você se sinta verdadeiramente acolhido e compreendido.
              </p>
              <p>
                Acredito que a terapia é uma jornada de transformação pessoal, onde cada pessoa tem o potencial de desenvolver recursos internos para lidar com seus desafios. Meu trabalho é guiá-lo nesse processo com empatia, respeito e técnicas baseadas em evidências científicas.
              </p>
              <p>
                Ao longo da minha carreira, tenho ajudado pessoas a superarem ansiedade, depressão, dificuldades nos relacionamentos e diversos outros desafios emocionais. Cada sessão é pensada de forma personalizada, respeitando seu ritmo e suas necessidades únicas.
              </p>
              <p className="font-semibold text-[#2C2C2C]">
                Estou aqui para caminhar ao seu lado nessa jornada de autoconhecimento e bem-estar. Vamos juntos?
              </p>
            </div>

            <button
              onClick={() => {
                const element = document.getElementById('agendar');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-8 bg-[#7DD3C0] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#6BC4B0] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              Agendar Primeira Sessão
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}